//@flow

export const singletonPromise = (
  func: (args: any) => Promise<any>
): ((args: any) => Promise<any>) => {
  const cache = {};

  const key = (args) => JSON.stringify(args);

  const removeFromCache = (args) => {
    // Don't keep stale and resolved promises!
    delete cache[key(args)];
  };

  const addCallToCache = (args) => {
    cache[key(args)] = func(...args).finally(() => removeFromCache(args));

    return cache[key(args)];
  };

  const getPromise = (args) => {
    // Check if promise is in the cache with this arguments
    if (cache[key(args)] == null) {
      // It's not in the cache, create a new one
      return addCallToCache(args);
    } else {
      // It is, return it
      return cache[key(args)];
    }
  };

  // $FlowFixMe
  return (...args: any) => getPromise(args);
};
